import * as React from 'react'

import { cn } from '@/lib/utils'

export type CardVariant = 'glass' | 'solid' | 'subtle'

function Card({
  className,
  variant = 'glass',
  ...props
}: React.ComponentProps<'div'> & { variant?: CardVariant }) {
  const variantClass =
    variant === 'solid'
      ? 'surface-panel'
      : variant === 'subtle'
        ? 'glass-subtle'
        : 'glass-elevated'

  return (
    <div
      data-slot="card"
      className={cn(
        'flex flex-col gap-4 overflow-hidden rounded-xl py-4 text-sm text-card-foreground',
        variantClass,
        className
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-header" className={cn('grid gap-1 px-4', className)} {...props} />
}

function CardTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-title" className={cn('text-base font-medium leading-snug', className)} {...props} />
}

function CardDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-description" className={cn('text-sm text-muted-foreground', className)} {...props} />
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn('px-4', className)} {...props} />
}

function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-footer"
      className={cn('flex items-center border-t border-white/10 bg-black/10 p-4', className)}
      {...props}
    />
  )
}

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
